import { Dispatch } from 'redux';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { LockerPosition, PackageCandidate } from '../../models/microservices';

export const updateIsAgentProcess = (isAgentProcess: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_IS_AGENT_PROCESS,
      payload: isAgentProcess,
    });
  };
};
export const updateCurrentLockerPosition = (lockerPosition: LockerPosition) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_CURRENT_LOCKER_POSITION,
      payload: lockerPosition,
    });
  };
};
export const updateCurrentPackageCandidate = (
  packageCandidate: PackageCandidate
) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_CURRENT_PACKAGE_CANDIDATE,
      payload: packageCandidate,
    });
  };
};
export const updateRemoveLockerList = (lockerRemoveList: LockerPosition[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_REMOVE_LOCKER_LIST,
      payload: lockerRemoveList,
    });
  };
};
export const updateEmployeeNumber = (employeeNumber: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_EMPLOYEE_NUMBER,
      payload: employeeNumber,
    });
  };
};
export const updateIsMultiDelivery = (isMultidelivery: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_IS_MULTIDELIVERY,
      payload: isMultidelivery,
    });
  };
};
export const updateCustomerName = (name: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_CUSTOMER_NAME,
      payload: name,
    });
  };
};
export const updateCustomerSignature = (signature: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_CUSTOMER_SIGNATURE,
      payload: signature,
    });
  };
};
export const updateLockerContent = (lockerContent: LockerPosition[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_LOCKER_CONTENT,
      payload: lockerContent,
    });
  };
};
export const updateLockerRackId = (lockerRackId: number) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_LOCKER_RACK_ID,
      payload: lockerRackId,
    });
  };
};
export const lockerReset = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.LOCKER_RESET,
    });
  };
};
